<template>
  <div v-if='isGrid || isList' class='properties-listing'>
    <div class='default-content'>
      <div v-if='properties && properties.length' class='properties-listing__area' :class="{ 'list-view': isList }">
        <div class='properties-item property' v-for='(property, propertyIdx) in properties'>
          <a :href='property.url' class='properties-item__image-holder'>
            <span class="property__label" :class="'property__label--' + property.status_presentation.color" v-if="property.status_presentation && property.status_presentation.visible" :style="{ backgroundImage: 'url(\'' + property.status_presentation.asset + '\')' }">
              <span class="property__label-text">{{ property.status_presentation.label }}</span>
            </span>
            <div v-if='cardPhotos(property).length' class='properties-item__slider'>
              <template v-for='(photo, photoIdx) in initialCardPhotos(property)'>
                <span v-if='photoIdx === cardPhotoPreviewLimit() - 1 && cardPhotos(property).length > cardPhotoPreviewLimit()'
                      :key='"slide-" + photo.src'
                      class='properties-item__slider-slide'>
                  <img class='properties-item__slider-image js-protected-property-photo' draggable='false'
                       :src='photo.src'
                       :srcset='photo.srcset || null'
                       sizes='(min-width: 1024px) 33vw, (min-width: 768px) 50vw, calc(100vw - 40px)'
                       alt='Property image'
                       loading='lazy'
                       decoding='async' />
                  <span class='properties-item__slider-more' aria-hidden='true'>
                    <span class='properties-item__slider-more-label'>Bekijk alle {{ cardPhotos(property).length }} foto's</span>
                  </span>
                </span>
                <img v-else
                     :key='photo.src'
                     class='properties-item__slider-image js-protected-property-photo' draggable='false'
                     :src='photo.src'
                     :srcset='photo.srcset || null'
                     sizes='(min-width: 1024px) 33vw, (min-width: 768px) 50vw, calc(100vw - 40px)'
                     alt='Property image'
                     :loading="(propertyIdx === 0 && photoIdx === 0) ? 'eager' : 'lazy'"
                     :fetchpriority="(propertyIdx === 0 && photoIdx === 0) ? 'high' : 'auto'"
                     :decoding="(propertyIdx === 0 && photoIdx === 0) ? null : 'async'" />
              </template>
            </div>
            <img v-else-if='property.publicListingCardPhoto || property.listingCardPhoto || property.listingMainPhoto' class='properties-item__image js-protected-property-photo' draggable='false' :src='property.publicListingCardPhoto || property.listingCardPhoto || property.listingMainPhoto' alt='Property image'/>
            <img v-else class='properties-item__image js-protected-property-photo' draggable='false' src='https://emanuel.org.au/wp-content/uploads/2022/11/Image-Placeholder-Dark.png' alt='Property image'/>
            <span v-if='(badgePhotos(property).length > 1) || (property.videos_count && property.videos_count > 0)'
                  class='properties-item__slider-count'
                  aria-hidden='true'>
              <span v-if='badgePhotos(property).length > 1'
                    class='properties-item__slider-count-item'>
                <i class='icon-image'></i>{{ badgePhotos(property).length }}
              </span>
              <span v-if='property.videos_count && property.videos_count > 0'
                    class='properties-item__slider-count-item'>
                <i class='icon-video'></i>{{ property.videos_count }}
              </span>
            </span>
          </a>
          <div class='properties-item__info'>
            <div class='properties-item__heading'>
              <a :href='property.url' class='properties-item__title-link'>
                <div class='properties-item__address'>{{ [property.postcode, property.location && property.location.name].filter(Boolean).join(', ') }}</div>
                <div class='properties-item__name'>{{ property.listingAddressIn }}</div>
              </a>
              <a :href='property.url' class='properties-item__price-link'>
                <template v-if='!isStaffHousing && property.show_price==1'>
                  <template v-if="booking == 1">
                    <div class='properties-item__price'>
                      <span class='properties-item__price-value' v-if="property.booking_period == 1">€ {{ property.ah_day_price && property.ah_day_price.indexOf(',00') == -1 ? (property.ah_day_price.indexOf(',') != -1 ? property.ah_day_price : property.ah_day_price + ',-') : (property.ah_day_price ? property.ah_day_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                      <span class='properties-item__price-value' v-else-if="property.booking_period == 2">€ {{ property.ah_week_price && property.ah_week_price.indexOf(',00') == -1 ? (property.ah_week_price.indexOf(',') != -1 ? property.ah_week_price : property.ah_week_price + ',-') : (property.ah_week_price ? property.ah_week_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                      <span class='properties-item__price-value' v-else>€ {{ property.ah_price && property.ah_price.indexOf(',00') == -1 ? (property.ah_price.indexOf(',') != -1 ? property.ah_price : property.ah_price + ',-') : (property.ah_price ? property.ah_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                      <span class='properties-item__price-note' v-if="property.booking_period == 1">{{ locales.property && locales.property.a_day }}</span>
                      <span class='properties-item__price-note' v-else-if="property.booking_period == 2">{{ locales.property && locales.property.a_week }}</span>
                      <span class='properties-item__price-note' v-else>{{ locales.properties && locales.properties.a_month }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class='properties-item__price'>
                      <span class='properties-item__price-value'>€ {{ property.ah_price && property.ah_price.indexOf(',00') == -1 ? (property.ah_price.indexOf(',') != -1 ? property.ah_price : property.ah_price + ',-') : (property.ah_price ? property.ah_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                      <span class='properties-item__price-note'>{{ locales.properties && locales.properties.a_month }}</span>
                    </div>
                  </template>
                </template>
                <template v-else-if='!isStaffHousing'>
                  <div class='properties-item__price'>
                    <span class='properties-item__price-value'>{{locales.properties && locales.properties.price_on_request}}</span>
                  </div>
                </template>
                <template v-else>
                  <div class='properties-item__price'>
                    <span class='properties-item__price-value'>{{locales.properties && locales.properties.max_number_of_persons}} {{ property.max_people }}</span>
                  </div>
                </template>
                <template v-if="property.min_rental_period || property.max_rental_period">
                    <div class="relevant-properties__item-price">
                        <span class="relevant-properties__item-price-value" v-if='property.min_rental_period'>{{locales.common && locales.common.min}}
                            {{ property.min_rental_period }} {{locales.common && locales.common.months}}</span>
                        <template v-if='property.min_rental_period && property.max_rental_period'>
                             / 
                        </template>
                        <span class="relevant-properties__item-price-value" v-if='property.max_rental_period'>{{locales.common && locales.common.max}}
                            {{ property.max_rental_period }} {{locales.common && locales.common.months}}</span>
                    </div>
                </template>
              </a>
            </div>
            <div class='properties-item__bottom'>
              <div class='properties-item__parameters'>
                <div class='properties-item__parameters-item'>
                  <i class='icon-ruler'></i>
                  {{property.area}} m&#178;
                </div>
                <div class='properties-item__parameters-item'>
                  <i class='icon-bed'></i>
                  {{ property.no_bedrooms }}
                </div>
                <div class='properties-item__parameters-item'>
                  <i class='icon-furniture'></i>
                  {{ property.furnishing_object ? property.furnishing_object.value : '-' }}
                </div>
              </div>
              <a :href='property.url' class='theme-btn theme-btn--small theme-btn--theme'>
                {{locales.common && locales.common.view_more}}
                <i class='icon-go-right'></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-else class='properties-listing__empty'>
        <div class='properties-listing__empty-icon-holder'>
          <i class='icon-home properties-listing__empty-icon'/>
        </div>
        <div class='properties-listing__empty-title'>{{locales.properties && locales.properties.no_properties}}</div>
        <div class='properties-listing__empty-text'>{{locales.properties && locales.properties.try_reset_filters}}</div>
        <a class='theme-btn theme-btn--tertiary' @click='resetFilters'>
          <i class='icon-replay' style='font-size: 20px;'/>
          {{locales.properties && locales.properties.reset_filters}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapGetters(['metadata', 'locales']),
      layout() {
        return this.$store.getters.getPropertiesLayout;
      },
      properties() {
        return this.$store.getters.getPropertiesCollection || [];
      },
      isGrid: function() {
        return this.$store.getters.getPropertiesIsGrid;
      },
      isList: function() {
        return this.$store.getters.getPropertiesIsList;
      },
      isStaffHousing() {
        return typeof window !== 'undefined' && window.location.href.includes('staffhousing');
      }
    },
    props: {
      lang: {
        default: '',
        type: String,
      },
      site: {
        default: '',
        type: String,
      },
      booking: {
        default: 0,
        type: Number,
      },
    },
    methods: {
      resetFilters() {
        window.location.search = '';
      },
      // Number of slider images to render per card before the
      // "more photos" overlay appears. Source of truth for both the
      // slice and the overlay-trigger index.
      cardPhotoPreviewLimit() {
        return 10;
      },
      // Normalize card photo data. The front listing API serializes the PUBLIC (tenant-
      // watermarked) card fields; older/other payloads may still carry the legacy fields, so we
      // fall back to them. Prefers the responsive {src, srcset} shape; returns [] when neither is
      // present so the v-if collapses cleanly.
      cardPhotos(property) {
        const responsive = property.publicListingCardPhotosResponsive || property.listingCardPhotosResponsive;
        if (responsive && responsive.length) {
          return responsive;
        }
        const flat = property.publicListingCardPhotos || property.listingCardPhotos;
        if (flat && flat.length) {
          return flat.map(function (s) {
            return { src: s, srcset: '' };
          });
        }
        return [];
      },
      // Photo-count badge list: public (watermarked) field first, legacy fallback, else [].
      badgePhotos(property) {
        return property.publicListingCardPhotos || property.listingCardPhotos || [];
      },
      // Render only the first N slides initially to keep the DOM small.
      // The full list is retained in property data for the photo-count
      // badge; further slides are reached via the detail page.
      initialCardPhotos(property) {
        return this.cardPhotos(property).slice(0, this.cardPhotoPreviewLimit());
      },
    }
  };
</script>